{
  "tov.communications.email.attachments": "This message has attachments.",
  "tov.communications.email.introduction": "{sender} sent a new message on {occasion}.",
  "tov.communications.email.new_message": "You have a new message.",
  "tov.communications.email.open_thread": "Open thread",
  "tov.communications.email.subject_occasion": "{sender} sent you a message on {occasion}",
  "tov.communications.email.subject_thread": "{sender} messaged you about {thread}"
}
